import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";
const API_URL = axiosUrl.getAxiosUrl();

class EUCallNotificationsService {
  async markNotificationAsSeen(id) {
    return await axios
      .post(API_URL + `euCallNotifications/markNotificationAsSeen`, {
        id: id
      })
      .then(response => {})
      .catch(error => {
        store.commit("notifications/updateModalError", error.response.data),
          store.commit("notifications/enableModalError");
      });
  }

  async deleteNotification(id) {
    return await axios
      .post(API_URL + `euCallNotifications/deleteNotification`, {
        id: id
      })
      .then(response => {})
      .catch(error => {
        store.commit("notifications/updateModalError", error.response.data),
          store.commit("notifications/enableModalError");
      });
  }
}

export default new EUCallNotificationsService();
